
import { setAuth } from '@/lib/service';
import axios from '@lib/service';
import { CodeResponse, useGoogleLogin } from '@react-oauth/google';


export { GoogleOAuthProvider } from '@react-oauth/google';

export const useGoogleSignIn = () => {
    return useGoogleLogin({
        flow: 'auth-code',
        onSuccess: (response: Omit<CodeResponse, 'error' | 'error_description' | 'error_uri'>) => {

            // Send the Google authentication code to the API @ /auth/google
            const code = response.code;
            const redirect_uri = "postmessage";

            axios({
                data: { data: { code, redirect_uri } },
                method: 'POST',
                url: 'auth/google',
            })
                .then(function (response) {
                    // handle success
                    const { data /* , message  */ } = response;
                    setAuth(data);
                })
                .catch(function (error) {
                    // handle error
                    const message = error?.response?.data?.message || error.message;
                    console.log(JSON.stringify(error))
                });
        },

        onError: (error: Pick<CodeResponse, 'error' | 'error_description' | 'error_uri'>) => alert(JSON.stringify(error)),
    });
};

// // This hook returns a callback
// export const useGoogleSignIn = () => useGoogleLogin({ flow, onSuccess, onError });